import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ts_token');
    const savedUser = localStorage.getItem('ts_user');
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } catch {
        localStorage.removeItem('ts_token');
        localStorage.removeItem('ts_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password, userType) => {
    try {
      const endpoint = userType === 'admin' ? '/api/auth/login' : '/api/auth/vendor/login';
      const response = await axios.post(endpoint, { email, password });
      
      const token = response.data.token;
      const userData = response.data.user || response.data.vendor;
      // Add role based on login type
      if (userType === 'admin') {
        userData.role = userData.role || 'admin';
      } else {
        userData.role = 'vendor';
      }
      
      localStorage.setItem('ts_token', token);
      localStorage.setItem('ts_user', JSON.stringify(userData));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      setUser(userData);
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Login failed. Please try again.' 
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('ts_token');
    localStorage.removeItem('ts_user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  const isAdmin = () => user?.role === 'admin';
  const isVendor = () => user?.role === 'vendor';

  return (
    <AuthContext.Provider value={{ 
      user, 
      login, 
      logout, 
      loading, 
      isAdmin, 
      isVendor 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
